module.exports = __webpack_public_path__ + "static/img/zhjmintcb.c2aea83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/zhjmintcb.png
// module id = MEpD
// module chunks = 93